import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"

const IconGem = ({
  title = "Gem",
  viewBoxWidth = 64,
  viewBoxHeight = 64,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, ...otherProps }}>
    <g fill="none" fillRule="evenodd">
      <circle fill="#F77769" cx="32" cy="32" r="32" />
      <path
        d="M42.4 22c.4 0 .7.2.9.5l4.3 8.5c.3.4.2 1-.2 1.2L32.7 45.4a1 1 0 01-1.4 0L16.6 32.2a1 1 0 01-.2-1.2l4.3-8.5c.2-.3.5-.5 1-.5h20.7zm-20.2 2l-3.7 7.2L32 43.3l13.5-12-3.7-7.3H22.2z"
        fill="#FFF"
      />
    </g>
  </Svg.Icon>
)

export default IconGem
